class VariantPickers extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.section) {
      this.productContainer = document.getElementById(
        "ProductHero-" + this.dataset.section
      );
    }

    this.handleProductPickerLinkClick =
      this.handleProductPickerLinkClick.bind(this);
    this.productLinks = Array.from(
      this.querySelectorAll(".product-option-picker__product-link")
    );

    if (this.dataset.productPickerApp === "true") {
      this.productLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          this.handleProductPickerLinkClick(event, event.currentTarget);
        });
      });
    }

    this.optionNames = this.dataset.optionNames.split(",");
    this.onVariantChange(false);

    this.addEventListener("change", (e) => {
      if (
        e.target.classList.contains(
          "product-option-picker__product-link-select"
        )
      ) {
        this.handleProductPickerLinkClick(e, e.target);
      } else {
        this.onVariantChange(true);
      }
    });
  }

  handleProductPickerLinkClick(event, target) {
    const targetTagName = target.tagName.toLowerCase();
    const selectedLinkEl =
      targetTagName === "select"
        ? target.options[target.selectedIndex]
        : target;
    const selectedProductLink =
      selectedLinkEl && (selectedLinkEl.href || selectedLinkEl.dataset.href);
    if (!selectedProductLink) {
      return;
    }
    if (this.dataset.productPickerApp !== "true") {
      if (targetTagName === "select") {
        window.location.href = selectedProductLink;
      }
      return;
    }

    if (targetTagName === "a") {
      event.preventDefault();
    }

    this.selectedProductLink = selectedProductLink;

    this.productLinks.forEach((link) => {
      if (link.href === selectedProductLink) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
    const requestedProductLink = this.selectedProductLink;
    this.updateOptions();
    this.updateOptionLabels();

    const selectedProductRenderLink = `${this.selectedProductLink}${
      this.selectedProductLink.indexOf("?") === -1 ? "?" : "&"
    }section_id=${this.dataset.section}`;

    window.history.pushState({}, "", this.selectedProductLink);

    this.toggleAddButton(true);

    fetch(selectedProductRenderLink)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (requestedProductLink !== this.selectedProductLink) {
          return;
        }

        const sectionContainer = document.getElementById(
          `shopify-section-${this.dataset.section}`
        );
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const modalSource = html.querySelector('[id^="ProductModal-"]');
        const modalDestination = sectionContainer.querySelector(
          '[id^="ProductModal-"]'
        );
        if (modalSource && modalDestination) {
          modalDestination.parentElement.replaceChild(
            modalSource,
            modalDestination
          );
        }

        const sliderSource = html.querySelector(
          ".product-hero__image-container"
        );
        const sliderDestination = sectionContainer.querySelector(
          ".product-hero__image-container"
        );
        if (sliderDestination && sliderSource) {
          sliderDestination.innerHTML = sliderSource.innerHTML;
        }

        const headSource = html.querySelector(".product-hero__head-meta");
        const headDestination = sectionContainer.querySelector(
          ".product-hero__head-meta"
        );
        if (headSource && headDestination) {
          headDestination.innerHTML = headSource.innerHTML;
          const headScripts = Array.from(
            headDestination.querySelectorAll("script")
          );
          headScripts.forEach((headScript) => {
            const execScript = document.createElement("script");
            Array.from(headScript.attributes).forEach((attr) => {
              execScript.setAttribute(attr.nodeName, attr.nodeValue);
            });
            execScript.innerHTML = headScript.innerHTML;
            headScript.parentNode.appendChild(execScript);
            headScript.parentNode.removeChild(headScript);
          });
        }

        const variantPickerSource = html.getElementById(this.id);
        if (variantPickerSource) {
          const lazyImages = Array.from(
            variantPickerSource.querySelectorAll('img[loading="lazy"]')
          );
          lazyImages.forEach(function (img) {
            img.loading = "eager";
          });
          this.parentElement.replaceChild(variantPickerSource, this);
        }
      })
      .catch((_err) => {
        if (requestedProductLink === this.selectedProductLink) {
          window.location.href = this.selectedProductLink;
        }
        this.toggleAddButton(false);
      });

    return false;
  }

  onVariantChange(updateContent) {
    this.updateOptions();
    this.updateMasterId();

    this.updateOptionRestrictedContent();
    this.updateProductRestrictedContent();

    if (this.currentVariant) {
      this.updateVariantInput();
      if (updateContent) {
        this.updateURL();
        this.updateMedia();
      }
      this.updateProductPickerLinks();
      this.updateOptionLabels();
      this.toggleAddButton(!this.currentVariant.available, true);

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          variant: this.currentVariant,
        },
      });
    }
  }

  toggleAddButton(disable = true, changeText) {
    if (this.dataset.unavailable === "true") {
      return;
    }
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector(".js-add-to-cart-text");
    const fixedCtaButton = document.querySelector(".js-fixed-cta");
    if (!addButton) return;

    let text;
    if (changeText) {
      text = disable
        ? addButton.dataset.unavailableText || "Sold Out"
        : addButton.dataset.addToCartText || "Add to Cart";
    }

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (fixedCtaButton) {
        fixedCtaButton.setAttribute("disabled", "disabled");
        if (text) {
          fixedCtaButton.textContent = text;
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      if (text) {
        addButtonText.textContent = text;
      }
      if (fixedCtaButton) {
        fixedCtaButton.removeAttribute("disabled");
        if (text) {
          fixedCtaButton.textContent = text;
        }
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = Array.from(
      document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"],[id^="ProductModal-${this.dataset.section}"]`
      )
    );

    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(this.currentVariant.featured_media.id);
      }
    });
  }

  updateOptionRestrictedContent() {
    if (!this.productContainer) {
      return;
    }

    const restrictedBlocks = Array.from(
      this.productContainer.querySelectorAll(
        ".product-hero__option-restricted-block"
      )
    );
    restrictedBlocks.forEach((block) => {
      const failedMatch = this.options.find((value, index) => {
        const blockVal = block.getAttribute("data-option-" + (index + 1));
        return blockVal ? blockVal !== value : false;
      });
      block.hidden = !!failedMatch;
    });
  }
  updateProductRestrictedContent() {
    if (!this.productContainer) {
      return;
    }

    const restrictedBlocks = Array.from(
      this.productContainer.querySelectorAll(
        ".product-hero__product-restricted-block"
      )
    );
    restrictedBlocks.forEach((block) => {
      block.hidden = block.dataset.productRestriction !== this.dataset.product;
    });
  }

  updateProductPickerLinks() {
    if (!this.currentVariant) {
      return;
    }
    const productLinks = Array.from(
      this.querySelectorAll(".product-option-picker__product-link")
    );
    productLinks.forEach((link) => {
      try {
        const variantMap = link.dataset.variantMap.split(",").reduce((m, v) => {
          const variantDef = v.split(":");
          const variantId = variantDef.shift();
          m[variantDef.join(":")] = variantId;
          return m;
        }, {});
        const variantId = variantMap[this.currentVariant.title];
        if (variantId) {
          const productLink = link.href.split("?")[0];
          link.href = `${productLink}?variant=${variantId}`;
        }
      } catch (error) {}
    });

    const productPickerDropdown = this.querySelector(
      ".product-option-picker__product-link-select"
    );
    if (productPickerDropdown) {
      for (
        let optionIndex = 0;
        optionIndex < productPickerDropdown.options.length;
        optionIndex++
      ) {
        const optionEl = productPickerDropdown.options[optionIndex];
        try {
          const variantMap = optionEl.dataset.variantMap
            .split(",")
            .reduce((m, v) => {
              const variantDef = v.split(":");
              const variantId = variantDef.shift();
              m[variantDef.join(":")] = variantId;
              return m;
            }, {});
          const variantId = variantMap[this.currentVariant.title];
          if (variantId) {
            optionEl.dataset.href = `${
              optionEl.dataset.href.split("?")[0]
            }?variant=${variantId}`;
          }
        } catch (error) {}
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll("fieldset,.product-form__input")
    );
    this.options = [];
    fieldsets.forEach((fieldset) => {
      const radioButtons = Array.from(fieldset.querySelectorAll("input"));
      if (radioButtons.length) {
        const checked = radioButtons.find((radio) => radio.checked);
        if (checked) {
          const optionIndex = this.optionNames.indexOf(checked.name);
          if (optionIndex !== -1) {
            this.options[optionIndex] = checked.value;
          }
        }
      }
      const select = fieldset.querySelector("select");
      if (select) {
        const optionIndex = this.optionNames.indexOf(select.name);
        if (optionIndex !== -1) {
          this.options[optionIndex] = select.value;
        }
      }
    });
    this.optionsMap = this.options.reduce((map, value, index) => {
      map[this.optionNames[index]] = value;
      return map;
    }, {});
    const selectedPickerLinks = Array.from(
      this.querySelectorAll(
        ".product-option-picker__product-link[aria-current='page']"
      )
    );
    selectedPickerLinks.forEach((el) => {
      this.optionsMap[el.dataset.optionName] = el.dataset.optionValue;
    });
    const productPickerDropdown = this.querySelector(
      ".product-option-picker__product-link-select"
    );
    const selectedPickerOption =
      productPickerDropdown &&
      productPickerDropdown.options[productPickerDropdown.selectedIndex];
    if (selectedPickerOption) {
      this.optionsMap[selectedPickerOption.dataset.optionName] =
        selectedPickerOption.dataset.optionValue;
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateOptionLabels() {
    const fieldsets = Array.from(this.querySelectorAll(".product-form__input"));
    fieldsets.forEach((option) => {
      const optionName = option.dataset.option;
      const label = option.querySelector(".js-option-selected-value");
      if (label && this.optionsMap[optionName]) {
        label.textContent = this.optionsMap[optionName];
      }
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-pickers", VariantPickers);
